export default {
  state: {
    epgUpdateInterval: 10000,
  },
};
